import axios from "axios";
import config from "../Config.json";

const GetAllAccountTypeData = async () => {
    try {
        const AuthToken = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = AuthToken;
        
       try {
        const response = await axios.get(`${config.API_URL}/app/getAccountTypeData`, )
        return response
       } catch (error) {
        return []
       }
    } catch (error) {
        return error
    }
}

export default GetAllAccountTypeData;